import React, { useEffect, useState } from 'react'
import TitleSection from '../../../../../Shared/TitleSection/TitleSection'
import useApiRequest from '../../../../../Hooks/apiReq';
import { convertToINRFormat } from '../../../../../Utils/INRConvert';
import Loader from '../../../../../CommonComponets/Loader';

const MyRankOrg = () => {
    const [myRanksData, setMyRank] = useState([])
    const {
        error,
        loading,
        response,
        sendApiRequest: SendRequistApiRank,
    } = useApiRequest();
    useEffect(() => {
        const { AutoID, LoginToken, AppVersion } = JSON.parse(
            sessionStorage.getItem("loggedInUser")
        );
        SendRequistApiRank(
            "POST",
            "/GetAssociateRank",
            {
                AutoId: AutoID,
                DeviceType: "Android",
                AppVersion: AppVersion,
                LoginToken: LoginToken,
            },
            {
                onSuccess: (res) => {
                    console.log("MyRank", res)
                    setMyRank(res?.Response?.AssociateRankList)
                }
            }

        );
    }, []);

    if (error) {
        return <div className='content'>
            <p className='p fs-6 text-danger text-center'>{error}</p></div>
    }
    if (loading) {
        return <Loader />
    }
    return (
        <div className='content'>
            <div className="row">
                <div className="col-12">
                    <div className=" my-2 px-2"><TitleSection text={"My Rank"} /></div>
                    <div className="card p-2">
                        <div className="text-center h3">Your journey is unstoppable</div>
                        <div className=" text-center h5 " > next succes is just a few steps away!</div>
                        <div className=" my-rank-box d-flex align-item-center flex-column m-auto ">
                            <ul className=''>
                                {myRanksData?.length > 0 ? myRanksData.map((item, index, array) => {
                                    const prev = index > 0 ? array[index - 1] : null;
                                    return (
                                        item.Status == "Pending" ?
                                            <li className="ssm" key={index}>
                                                <div className={prev?.Status == "Active" ? "cr-left-active" : "cr-left"}>
                                                    <span >{(item?.DisplayAmount)}</span>
                                                </div>
                                                <div className="cr-right">
                                                    <span className={prev?.Status == "Active" ? "greencolor" : ""}>{item?.RankName}</span>
                                                    <p className={prev?.Status == "Active" ? "greencolor" : ""}>{item?.Remark}</p>
                                                </div>
                                            </li>
                                            :
                                            item.Status == "Achived" ?
                                                <li className="active" key={index}>
                                                    <div className="cr-left">
                                                        <span className='headingColor fw-bold '>{(item?.DisplayAmount)}</span>
                                                    </div>
                                                    <div className="cr-right">
                                                        <span>{item?.RankName}</span>
                                                        <p>{item?.Remark}</p>
                                                    </div>
                                                </li>
                                                : item.Status == "Active" &&
                                                <>
                                                    <li className="active text-success " key={index}>
                                                        <div className="cr-leftactive cr-left  text-success ">
                                                            <span className='fw-bold text-success '>{(item?.DisplayAmount)}</span>
                                                        </div>
                                                        <div className="cr-right text-success">
                                                            <span className='text-success'>Your Current Rank <strong>{item?.RankName}</strong></span>
                                                            <p className='text-success'>{item?.Remark}</p>
                                                        </div>
                                                    </li>
                                                    <li className="sm" key={index}>
                                                        <div className="sm-div">
                                                            <div className="sm-left">
                                                                <div className="lakh ">
                                                                    <span>{convertToINRFormat(item?.TargetAmt)}</span>
                                                                    <span className="bg">{convertToINRFormat(parseInt(item?.TotalBusiAchived))}</span>
                                                                </div>
                                                                <p className='headingColor'>
                                                                    <strong>{item?.RankName}</strong>{" "}
                                                                    <span>{item?.Remark}</span>{" "}
                                                                    {convertToINRFormat(parseInt(item?.TotalBusiAchived))} <span className='headingColor'>Total Business Achieved</span>
                                                                </p>
                                                            </div>
                                                            <div className="sm-right">
                                                                <span>{convertToINRFormat(parseInt(item?.RequiredBusiness))}</span>
                                                                <div className="more-next">More to Achieve NEXT</div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </>

                                    );
                                })
                                    :
                                    !loading && <p className='p fs-6 text-danger text-center'>No Record Found :)</p>
                                }

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default MyRankOrg